var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1577_3296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 52,
    height: 52
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    width: 52,
    height: 52,
    fill: "url(#paint0_linear_1577_3296)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1577_3296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.58344 50.9992V32.2495H3.8335V18.4997C3.8335 17.1247 4.32307 15.9477 5.30222 14.9685C6.28137 13.9894 7.45844 13.4998 8.83342 13.4998H16.3333C17.7083 13.4998 18.8853 13.9894 19.8645 14.9685C20.8436 15.9477 21.3332 17.1247 21.3332 18.4997V32.2495H17.5833V50.9992H7.58344ZM12.5834 10.9998C11.2084 10.9998 10.0313 10.5103 9.05216 9.53112C8.07301 8.55196 7.58344 7.3749 7.58344 5.99992C7.58344 4.62494 8.07301 3.44788 9.05216 2.46873C10.0313 1.48958 11.2084 1 12.5834 1C13.9583 1 15.1354 1.48958 16.1146 2.46873C17.0937 3.44788 17.5833 4.62494 17.5833 5.99992C17.5833 7.3749 17.0937 8.55196 16.1146 9.53112C15.1354 10.5103 13.9583 10.9998 12.5834 10.9998ZM33.3331 50.9992V35.9994H25.8332L32.2081 16.8747C32.5414 15.7914 33.156 14.9581 34.0518 14.3748C34.9476 13.7915 35.958 13.4998 37.083 13.4998C38.208 13.4998 39.2184 13.7915 40.1142 14.3748C41.01 14.9581 41.6246 15.7914 41.9579 16.8747L48.3328 35.9994H40.8329V50.9992H33.3331ZM37.083 10.9998C35.708 10.9998 34.531 10.5103 33.5518 9.53112C32.5727 8.55196 32.0831 7.3749 32.0831 5.99992C32.0831 4.62494 32.5727 3.44788 33.5518 2.46873C34.531 1.48958 35.708 1 37.083 1C38.458 1 39.635 1.48958 40.6142 2.46873C41.5933 3.44788 42.0829 4.62494 42.0829 5.99992C42.0829 7.3749 41.5933 8.55196 40.6142 9.53112C39.635 10.5103 38.458 10.9998 37.083 10.9998Z",
    fill: "url(#paint1_linear_1577_3296)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1577_3296",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C43E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1577_3296",
    x1: 26.0832,
    y1: 3.79956,
    x2: 26.0832,
    y2: 116.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C43E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.57029635f13831e8ecebf22c42cee03d.svg";
export { ForwardRef as ReactComponent };